<ion-header>
  <ion-toolbar>
    <ion-title>Add Tap to Tower</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-card class="ion-no-padding">
    <ion-card-content class="ion-no-padding">
      <ion-list lines="full">
        @for(item of items(); track item.id){
          <ion-item
            button
            (click)="selectTap(item)">
            <ion-label>
              <h2>{{item.name}}</h2>
              @if(item.order) {
                <p>Order: {{item.order}}</p>
              }
            </ion-label>
          </ion-item>
        }

        @if(items().length === 0) {
          <ion-item class="no-taps-message">
            <ion-label>
              <h3>No available taps</h3>
              <p>All taps are already assigned to towers or you don't have any taps yet.</p>
            </ion-label>
          </ion-item>
        }
      </ion-list>
    </ion-card-content>
  </ion-card>
</ion-content>
